import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, from, empty } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { Listing } from '../classes/listing';
import { PreRenderService } from '../services/pre-render.service';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory } from '../classes/enums';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ListingResolver implements Resolve<Listing> {

  constructor(
    private _listingsService: ListingsService,
    private _router: Router,
    private _preRenderService: PreRenderService,
    private _communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<Listing> {
    let listingIdWithBoardPrefix = '0';
    const listingIdRegex = /-(\w+_\w+)-lst/;

    const pathToBeChecked = route.url.length === 4 ? route.url[3].path : route.url[2].path;
    const listingIdMatches = listingIdRegex.exec(pathToBeChecked);
    if (listingIdMatches && listingIdMatches.length === 2) listingIdWithBoardPrefix = listingIdMatches[1];

    return from(this._listingsService.getListingDetails(listingIdWithBoardPrefix)).pipe(
      map(listing => {
        this._communicationService.setCurrentListingType(listing.isCommercial ? ListingCategory.COMMERCIAL : listing.isLuxury ? ListingCategory.LUXURY : ListingCategory.RESIDENTIAL);
        return listing;
      }),
      catchError((err) => {
        const fallbackUrl = route.url.length === 4 ? route.url[0] + '/' + route.url[1] + '/' + route.url[2] : route.url[0] + '/' + route.url[1];
        this._router.navigate(['/' + fallbackUrl]);
        this._preRenderService.setPreRenderFlag(301, fallbackUrl);
        return empty();
      }));
  }
}
